// extracted by mini-css-extract-plugin
export var parcelRow = "_tb-0";